import React from "react";
import { ToastSuccess } from "@bloomberg/media-ui-core";
import styles from "./styles.module.css";

interface SuccessToastProps {
  isOpen: boolean;
}

const SuccessToast = React.memo(({ isOpen }: SuccessToastProps) => (
  <ToastSuccess
    className={styles.toast}
    open={isOpen}
    text={
      (
        <p>
          You&#39;re signed up! Check your inbox for confirmation or{" "}
          <a
            href="/newsletters"
            target="_blank"
            rel="noopener"
            className="underline"
          >
            browse all newsletters
          </a>
          .
        </p>
      ) as unknown as string
    }
  />
));

SuccessToast.displayName = "SuccessToast";

export default SuccessToast;
